import { useEffect, useState } from 'react';
import { assistantCache } from 'app/domains/assistant';
export const useAssistantCacheListener = (callback, keys) => {
    const [assistantItem, setAssistantItem] = useState(assistantCache.read());
    useEffect(() => {
        const handleKeyUpdate = (assistant) => {
            setAssistantItem(assistant);
        };
        assistantCache.onUpdate(keys, handleKeyUpdate);
        return () => {
            assistantCache.off(handleKeyUpdate);
        };
    }, [keys, callback]);
    return callback(assistantItem);
};
